module.exports = __webpack_public_path__ + "static/media/gold-texture.c44636e9.jpg";